import { signOut } from 'firebase/auth'
import React, { useContext } from 'react'
import { auth } from '../../firebase'
import { AuthContext } from '../../context/AuthContext';

const Nav = () => {
  const {currentUser} = useContext(AuthContext);
  return (
    <div className='nav' >
      <span className="logo">ConvoConnect! <img src="icons/talking.png" alt='meeting-icon'/> </span>
      <div className="user">
        <img src={currentUser.photoURL} alt="" />
        <span>{currentUser.displayName}</span>
        <button 
        onClick={()=> {
          window.location.reload();
          signOut(auth)}} 
        >
        Logout</button>
      </div>
    </div>
  )
}

export default Nav